// extracted by mini-css-extract-plugin
export default {"nav":"styles_nav__rrQEp","active":"styles_active__2qX+b"};